import immutableUpdate from 'react-addons-update';
import moment from 'moment-timezone';
import { stringToBoolean } from '../utilities/conversionUtility';

import {
  SET_STYLE,
  SET_SETTING,
  SET_CONFIGURATION,
  SET_TRANSLATION,
  SET_DEFAULT_TRANSLATION,
  SET_DEFAULT_SETTING,
  SET_TIME_ZONE,
  SET_URL_PARAM,
} from '../actions/settings';

const initialState = {
  style: {},
  setting: {},
  translation: {},
  defaultTranslation: {},
  defaultSetting: {},
  exceededTrialPlan: false,
  bookingFields: [],
  timeZone: window.bta.timeZone || moment.tz.guess(),
  quantityRange: false,
  urlParams: {},
};

function convertDataType(setting) {
  for (const key in setting) {
    const value = setting[key];

    if (['display_time_range', 'show_remaining_places', 'show_price', 'show_location_chooser', 'show_resource_chooser', 'show_location', 'display_legend'].includes(key)) {
      setting[key] = stringToBoolean(value);
    } else if (['when_expired', 'reservation_expiry_minutes'].includes(key)) {
      setting[key] = parseInt(value, 10);
    }
  }
  return setting;
}

export default function settings(state = initialState, action) {
  switch (action.type) {
    case SET_STYLE:
      return immutableUpdate(state, {
        style: { $merge: action.value },
      });

    case SET_SETTING:
      return immutableUpdate(state, {
        setting: { $merge: { [action.key]: action.value } },
      });

    case SET_CONFIGURATION:
      return {
        ...state,
        ...action.value,
        setting: convertDataType(action.value.setting || {}),
        exceededTrialPlan: action.value.exceededTrialPlan,
        bookingFields: filterBookingFieldsByTags(action.value.bookingFields, action.value.product),
        quantityRange: action.value.quantityRange,
        urlParams: action.value.urlParams,
      };

    case SET_TRANSLATION:
      return immutableUpdate(state, {
        translation: { $merge: { [action.key]: action.value } },
      });

    case SET_DEFAULT_TRANSLATION:
      return immutableUpdate(state, {
        defaultTranslation: { $merge: action.value },
      });

    case SET_DEFAULT_SETTING:
      return immutableUpdate(state, {
        defaultSetting: { $merge: convertDataType(action.value) },
      });

    case SET_TIME_ZONE:
      return immutableUpdate(state, {
        timeZone: { $set: action.value },
      });

    case SET_URL_PARAM:
      return immutableUpdate(state, {
        urlParams: { $merge: { [action.key]: action.value } },
      });

    default:
      return state;
  }
}

function filterBookingFieldsByTags(bookingFields, product) {
  if (!bookingFields) return [];
  const fields = JSON.parse(bookingFields),
        tags = product.tag_list || [];

  return fields.filter((f) => !f.tags || f.tags.length == 0 || f.tags.some(t => tags.includes(t)));
}